import { MetricBox } from 'components/UI/V3/MetricBox/MetricBox';
import { Tooltip } from 'components/UI/V3/Tooltip/Tooltip';
import styles from './SummaryCards.module.scss';

interface SummaryCardsProps {
    sales?: number;
    clients?: number;
}

const SummaryCards = ({ sales, clients }: SummaryCardsProps) => {
    const MetricBoxTitle = ({ title, tooltipContent }: { title: string; tooltipContent: string }) => {
        return (
            <div className={styles.metricBoxTitleContainer}>
                <h3 className={styles.metricBoxTitle}>{title}</h3>
                <Tooltip
                    content={tooltipContent}
                    className={styles.tooltipContent}
                >
                    <div className={styles.tooltipIcon}>
                        <span>i</span>
                    </div>
                </Tooltip>
            </div>
        );
    };

    return (
        <div className={styles.summaryCards}>
            <MetricBox
                title={
                    <MetricBoxTitle
                        title="Total Sales"
                        tooltipContent="Total value of sales with this promo code applied"
                    />
                }
                value={`$${sales}`}
                className={styles.summaryCard}
            />
            <MetricBox
                title={
                    <MetricBoxTitle
                        title="Total Clients"
                        tooltipContent="Total number of clients who used this promo code"
                    />
                }
                value={clients}
                className={styles.summaryCard}
            />
        </div>
    );
};

export default SummaryCards;
